import type { PocInputValidity } from 'commons/types';
import { SelectOption, SelectPropsValue } from 'commons/components';
import { MAX_OPTIONS_WITHOUT_SEARCH } from 'core/constants/constants';
import React from 'react';
import {
    findParentsAndChildrenByKey,
    getParentNameByChildValue,
} from 'modules/settings/pods/settings-automation-rules/constants/functions';
import {
    ActionOptionsContainer,
    AutomationRulesSelect,
    TrainingProgramPrefix,
} from 'modules/settings/pods/settings-automation-rules/styled/automation-rules.style';
import { BaseProps } from '../field-conditional.type';

export interface SingleSelectFieldProps extends BaseProps {
    name: string;
    label?: string;
    placeholder?: string;
    options?: SelectOption[];
    defaultSelectedOption?: SelectPropsValue;
    type?: string;
    virtualized?: boolean;
}

const defaultValidation: PocInputValidity = {
    state: 'valid',
};

export const SingleSelectField: React.FC<SingleSelectFieldProps> = (props) => {
    const { name, label, placeholder, options, type, defaultSelectedOption, virtualized, onChange } = props;

    const [validity, setValidity] = React.useState(structuredClone(defaultValidation));
    const [state, setState] = React.useState(defaultSelectedOption);

    const trainingProgram = getParentNameByChildValue({ data: options ?? [], childValue: state });

    const onSingleSelectChange = (_optionName: string, optionId: SelectPropsValue) => {
        const result = findParentsAndChildrenByKey(options, optionId as string[], 'value');
        const { parentValue, childValue } = result[0] || {};
        const newValue = {
            enrollmentsData: [
                {
                    trainingProgramId: parentValue,
                    trainingStageId: childValue,
                },
            ],
        };
        onChange({ key: name, value: newValue, type: type ?? '' });
        setState(childValue);
    };

    const onClearHandler = () => {
        onChange({ key: name, value: undefined, type: type ?? '' });
        setState(undefined);
    };

    return (
        <ActionOptionsContainer>
            <AutomationRulesSelect
                className="singleSelectField"
                prefixProps={<TrainingProgramPrefix>{trainingProgram}</TrainingProgramPrefix>}
                name={name}
                label={label}
                placeholder={placeholder}
                value={state}
                options={options || []}
                searchable={(options?.length ?? 0) > MAX_OPTIONS_WITHOUT_SEARCH}
                showSelectorControl
                noBorder
                clearButton
                floatingAssistiveText
                size="small"
                required
                onValidity={(_field: string, newValidity: PocInputValidity) => {
                    setValidity(newValidity);
                }}
                validity={validity}
                onChange={onSingleSelectChange}
                onClear={onClearHandler}
                virtualized={virtualized}
                $hasContent={!!state}
            />
        </ActionOptionsContainer>
    );
};
